<template>
  <div style="width: 100%;">
    <h3>Internal Collaboration</h3>
    <el-row style="padding: 5px;" v-if="!onlyTable" >  
      <el-col :span="2"><el-button type="success" @click="addTableData()">{{$t('button.create')}}</el-button></el-col> 
    </el-row>   
    <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
      <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
        <template slot-scope="scope">    
          <span >{{ scope.row[v.field] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('action')" width="290" v-if="!onlyTable">
        <template slot-scope="scope">   
          <el-button type="warning" @click="updTableData(scope.row, scope.$index)">{{$t('button.edit')}}</el-button>        
          <el-button type="danger" @click="delTableData(scope.row, scope.$index)">{{$t('button.delete')}}</el-button>
          <el-button v-if="currentIndex!=scope.$index && scope.row.feedbackId != null && scope.row.feedbackId != ''" type="primary" @click="sendMail(scope.row, scope.$index, true)">{{$t('button.sendMail')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog ref="editDialog" title="編輯信件" :visible.sync="dialogVisible" width="70%" :before-close="handleClose" :lock-scroll=true
      :close-on-click-modal=false :close-on-press-escape =false :show-close=false>
      <el-form :model="editFileForm"  label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.notifyDept')">  
              <el-select v-model="editFileForm.department" :placeholder="$t('msg.pleaseSelect')" multiple @change="changeDept()" style="width:100%">
                <el-option v-for="item in departmentOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.mailTo')" >  
              <MailToSearch ref="mailToObj" :pselectValue.sync="selectedMailTo" @sync-mailTo="syncSelectedMailTo" /> 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.mailTitle')" >  
              <el-input v-model="editFileForm.mailTitle" maxlength=1000></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('field.mailContent')" >
              <el-input type="textarea" v-model="editFileForm.mailContent" maxlength=4000 rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        </el-form>  
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
          <el-button type="warning" @click="confirmEdit">{{$t('button.confirm')}}</el-button>
        </span>         
    </el-dialog>
  </div>
</template>

<script>
import { apiFindFeedbackCollaborateByFeedbackId, apiSendFeedbackCollaborateMail, apiFindSysValueByCategory, apiFindIncxWindowsByDepartment } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import MailToSearch from "../MailToSearch";
import CommonUtil from "../../../utils/commonUtil.js";



export default {
  props: {    
    pFeedbackId: {
      type: String
    },
    onlyTable: {
      type: Boolean,
      Default: false
    }
  },
  data() {   
    return {    
      selectedMailTo:'',
      dialogVisible:false,
      currentIndex:-1,
      departmentOpts:[],
      tableData: {
        sel: null,
        columns: [   
          { field: "department", title: this.$i18n.t('field.notifyDept'), width: 100 },         
          { field: "mailTitle", title: this.$i18n.t('field.mailTitle') },
          { field: "mailContent", title:this.$i18n.t('field.mailContent') },
          { field: "mailTo", title: this.$i18n.t('field.mailTo')}
        ],
        data: []
      },      
      editFileForm:{
        department:'',
        mailTitle:'',
        mailContent:'',
        action:'',
        id:'',
        currentIndex:-1,
        
      }
    };
  }, 
  components: {
    MailToSearch    
  },
  watch:{   
     
  },
  mounted() {
    if(this.pFeedbackId != null && this.pFeedbackId != ''){      
      apiFindFeedbackCollaborateByFeedbackId({ headers: authHeader(), feedbackId: this.pFeedbackId}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data.length > 0){
          this.tableData.data = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }

    apiFindSysValueByCategory({ headers: authHeader(), condition: 'INCX_POSITION'}).then((response) => {       
      response.data.forEach((item, index) => {   
        this.departmentOpts.push({ value: item.value });
      });
      this.departmentOpts.push({ value: 'Other' });
    }).catch((err) => {
      console.log(err);
    });
  },
  methods: {
    addTableData() {
      this.editFileForm.department = [];
      this.editFileForm.mailTitle = '';   
      this.editFileForm.mailContent = '';  
      this.editFileForm.action = 'A';
      this.selectedMailTo = '';
      this.dialogVisible = true;
    },
    updTableData(row, index) {            
      //是否是取消操作
      row.action = 'U';
      this.dialogVisible = true;     
      this.editFileForm = Object.assign({}, row); 
      this.editFileForm.currentIndex = index;  
      this.selectedMailTo = row.mailTo;
      this.editFileForm.department = [];
      if(row.department!=null){
        let tempArr = row.department.split(';');
        tempArr.forEach((item, index) => {  
          if(item != null && item != ''){
              this.editFileForm.department.push(item)
          }  
        })        
      }        
    },
    delTableData(row, index){  
      this.$confirm(this.$i18n.t('msg.confirmDelete'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.tableData.data.splice(index, 1);        
        done();
      }).catch(_ => {});
    },
    sendMail(row, index){

      this.$confirm( '確定要寄信給'+row.mailTo, {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        apiSendFeedbackCollaborateMail({ headers: authHeader(), id:row.id}).then((response) => {    
          if(response.data != null && response.data){
            
            this.$message({ type: "success", message: this.$i18n.t('msg.sendMailSuccess'), duration: 800});   
          }
        }).catch((err) => {
          this.$message({ type: "error", message: this.$i18n.t('msg.sendMailFail'), duration: 800});   
          console.log(err);
        });       
        done();
      }).catch(_ => {});      
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {          
        this.dialogVisible = false;          
        done();
      }).catch(_ => {});
    },
    confirmEdit(){

      let deptStr = '';
      this.editFileForm.department.forEach((item, index) => {   
        deptStr += item+';';
      });

      if( this.editFileForm.action == 'A' && (CommonUtil.isNull(deptStr) || CommonUtil.isNull(this.editFileForm.mailTitle)|| 
          CommonUtil.isNull(this.editFileForm.mailContent) || this.$refs.mailToObj.selectValue.length==0)){
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      } else {  
        var newData = {
          action: this.editFileForm.action == 'A'? 'A': 'U',
          department: deptStr,
          mailTitle: this.editFileForm.mailTitle,
          mailContent: this.editFileForm.mailContent,
          mailTo: CommonUtil.arrToStr(this.$refs.mailToObj.selectValue),         
          id: this.editFileForm.action == 'A'? '' : this.editFileForm.id,
          feedbackId: this.feedbackId
        };    

        if(this.editFileForm.action == 'A'){
          this.tableData.data.splice(0, 0, newData);
          this.tableData.sel = JSON.parse(JSON.stringify(newData)); 
          this.$refs.mailToObj.selectValue =[];       
        } else {
          this.$set( this.tableData.data,  this.editFileForm.currentIndex, newData);
        }
       
        this.dialogVisible = false;   
      }
    },
    syncSelectedMailTo(newMailTo){
      this.selectedMailTo = newMailTo;
    },
    changeDept(){
      if(this.editFileForm.department.length > 0){
        let deptStr = '';
        this.editFileForm.department.forEach((item, index) => {   
          deptStr += item+';';
        });
        
        apiFindIncxWindowsByDepartment({ headers: authHeader(), condition: this.pFeedbackId, condition1: deptStr}).then((response) => {           
          if(response.status== 200 && response.data != null && response.data.length > 0){
            let arr = response.data.split(";");
            let newMailTo = this.selectedMailTo;
            arr.forEach((item, index) => {  
              if(item != null && item != ''){
                if(this.selectedMailTo.indexOf(item) == -1){
                  newMailTo +=item+';';
                }
              }  
            });   
            this.selectedMailTo = newMailTo;      
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  }
};
</script>
